import { Model } from "vue-mc";

export class SubStatus extends Model {
  defaults() {
    return {
      clave: null
      , code: null
      , vacio: false
      , descripcion: ""
      , accion: ""
      , statusprecontacto: ""
      , postest: ""
      , canalaceptacion: ""
      , tipo: ""
      , clonable: true
      , payfac: false
      , gaps: false
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , code: (code) => code
      , vacio: (vacio) => vacio
      , descripcion: (descripcion) => descripcion
      , accion: (accion) => accion
      , statusprecontacto: (statusprecontacto) => statusprecontacto
      , postest: (postest) => postest
      , canalaceptacion: (canalaceptacion) => canalaceptacion
      , tipo: (tipo) => tipo
      , clonable: (clonable) => clonable
      , payfac: (payfac) => payfac
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/substatus.js